import React from 'react';
// import { useState, useEffect } from 'react';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';
import './MediaPage.css';

// オウンドメディアのAPI URL（実際の実装では環境変数を使用）
// const OWNED_MEDIA_API_URL = 'http://localhost:3001/api'; // オウンドメディアのAPI URL

function MediaPage() {
  // オウンドメディアの最新記事を取得（現在非表示）
  // const [latestArticles, setLatestArticles] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);
  // const [error, setError] = useState(null);

  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'メディア', path: '/media' }
  ];

      // オウンドメディアの最新記事を取得（現在非表示）
      // useEffect(() => {
      //   const fetchLatestArticles = async () => {
      //     try {
      //       setIsLoading(true);
      //       setError(null);
      //       
      //       // メインHP用の同期データを取得
      //       const mainHPData = localStorage.getItem('main_hp_owned_media_data');
      //       if (mainHPData) {
      //         const data = JSON.parse(mainHPData);
      //         setLatestArticles(data.latestArticles || []);
      //       } else {
      //         // フォールバック用のモックデータ
      //         const mockResponse = {
      //           success: true,
      //           data: [
      //             {
      //               id: 1,
      //               title: '1on1で成果を出したマネージャーの5つのポイント',
      //               category: 'マネジメント',
      //               excerpt: '効果的な1on1の進め方と、部下の成長を促進するための具体的な手法を解説します。',
      //               publish_date: '2024年1月20日',
      //               read_time: '5分'
      //             },
      //             {
      //               id: 2,
      //               title: '営業教育で成果を上げるOJTの設計方法',
      //               category: '営業教育',
      //               excerpt: '現場での実務を通じた効果的な営業教育の進め方と、成果測定のポイントを紹介します。',
      //               publish_date: '2024年1月18日',
      //               read_time: '7分'
      //             },
      //             {
      //               id: 3,
      //               title: 'コンピテンシー評価制度の導入事例',
      //               category: '評価制度',
      //               excerpt: '企業の人事評価制度にコンピテンシーを導入した成功事例と、その効果を詳しく解説します。',
      //               publish_date: '2024年1月15日',
      //               read_time: '6分'
      //             }
      //           ]
      //         };
      //         
      //         setLatestArticles(mockResponse.data);
      //       }
      //     } catch (err) {
      //       console.error('Failed to fetch latest articles:', err);
      //       setError('記事の取得中にエラーが発生しました');
      //     } finally {
      //       setIsLoading(false);
      //     }
      //   };

      //   fetchLatestArticles();

      //   // オウンドメディアデータ更新イベントをリッスン
      //   const handleDataUpdate = (event) => {
      //     const data = event.detail;
      //     setLatestArticles(data.latestArticles || []);
      //   };

      //   window.addEventListener('ownedMediaDataUpdated', handleDataUpdate);

      //   return () => {
      //     window.removeEventListener('ownedMediaDataUpdated', handleDataUpdate);
      //   };
      // }, []);


  return (
    <div>
      <SEO page="media" />

      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">MEDIA</p>
          <h1 className="ds-h1">メディア</h1>
          <p className="ds-lead">
            PortRay株式会社の最新ニュース、プレスリリース、動画コンテンツなどをご紹介します。
          </p>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">YOUTUBE</p>
            <h2 className="ds-h2">YouTubeチャンネル</h2>
          </div>
          <ul className="media-channels">
            <li className="ds-card media-channel">
              <div className="media-channel-image">
                <img src="/images/YoutubeCH.jpg" alt="転職エンジェル" />
              </div>
              <div className="media-channel-info">
                <h3 className="ds-h3">転職エンジェル</h3>
                <p>転職活動のノウハウや業界情報をお届けするチャンネル</p>
                <a
                  href="https://www.youtube.com/@tenshoku_angel"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ds-btn ds-btn--line"
                >
                  <i className="fab fa-youtube" aria-hidden="true"></i>
                  チャンネルを見る
                </a>
              </div>
            </li>

            <li className="ds-card media-channel">
              <div className="media-channel-image">
                <img src="/images/YoutubeCH2.jpg" alt="Work Tour" />
              </div>
              <div className="media-channel-info">
                <h3 className="ds-h3">Work Tour</h3>
                <p>働き方やキャリアについて考えるチャンネル</p>
                <a
                  href="https://www.youtube.com/@worktour6263"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ds-btn ds-btn--line"
                >
                  <i className="fab fa-youtube" aria-hidden="true"></i>
                  チャンネルを見る
                </a>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <section className="ds-section ds-section--alt">
        <div className="container">
          <div className="ds-section-head">
            <p className="ds-eyebrow">OWNED MEDIA</p>
            <h2 className="ds-h2">TryBase</h2>
          </div>
          <div className="ds-card media-trybase">
            <div className="media-trybase-image">
              <img src="/images/trybase.jpg" alt="OSUMITSUKI TryBase" />
            </div>
            <div className="media-trybase-info">
              <h3 className="ds-h3">OSUMITSUKI TryBase</h3>
              <p>
                人材育成・評価に関するナレッジやノウハウを発信するオウンドメディアです。
              </p>
              <a
                href="https://osumitsuki-trybase.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="ds-btn ds-btn--primary ds-btn--arrow"
              >
                TryBaseを見る
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* オウンドメディアの最新記事セクション（現在非表示。旧CSSは削除済みのため、再表示する際は ds-section / ds-card で組み直す） */}
      {/* <div className="owned-media-section">
        <h2 className="section-title">オウンドメディア最新記事</h2>
        <p className="section-description">
          人材育成に関する最新の記事を3つご紹介します。
        </p>
        <div className="owned-media-articles">
          {isLoading ? (
            <div className="loading-message">
              <p>記事を読み込み中...</p>
            </div>
          ) : error ? (
            <div className="error-message">
              <p>{error}</p>
            </div>
          ) : (
                latestArticles.map((article) => (
                  <a 
                    key={article.id} 
                    href={`/owned-media/article/${article.id}`} 
                    className="owned-media-article-card"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="article-category">{article.category}</div>
                    <h3 className="article-title">{article.title}</h3>
                    <p className="article-excerpt">{article.excerpt}</p>
                    <div className="article-meta">
                      <span className="publish-date">{article.publish_date}</span>
                      <span className="read-time">{article.read_time}</span>
                    </div>
                  </a>
                ))
          )}
        </div>
        <div className="view-all-articles">
          <a 
            href="/owned-media" 
            target="_blank"
            rel="noopener noreferrer"
            className="view-all-button"
          >
            すべての記事を見る →
          </a>
        </div>
      </div> */}
    </div>
  );
}

export default MediaPage;
